import styled from 'styled-components';

export const SettingsPage = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

export const PageHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;
`;

export const PageTitle = styled.h2`
  font-size: 28px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
`;

export const SaveSettingsButton = styled.button`
  background: #30D5C8;
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background: #26a79d;
  }
`;

export const SettingsContainer = styled.div`
  display: grid;
  grid-template-columns: 250px 1fr;
  gap: 30px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

export const SettingsSidebar = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
  padding: 20px 0;
  height: fit-content;

  @media (max-width: 768px) {
    order: 2;
  }
`;

export const SettingsNav = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    flex-direction: row;
    overflow-x: auto;
    padding: 0 20px;
  }
`;

export const SettingsTab = styled.button`
  background: none;
  border: none;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
  font-size: 14px;
  color: #64748b;
  border-left: 3px solid transparent;

  &:hover {
    background: #f8fafc;
    color: #334155;
  }

  &.active {
    background: #f0f9ff;
    color: #3b82f6;
    border-left-color: #3b82f6;
  }

  @media (max-width: 768px) {
    white-space: nowrap;
    border-left: none;
    border-bottom: 3px solid transparent;
    padding: 12px 16px;

    &.active {
      border-left-color: transparent;
      border-bottom-color: #3b82f6;
    }
  }
`;

export const TabIcon = styled.span`
  font-size: 18px;
  width: 20px;
  text-align: center;
`;

export const TabLabel = styled.span`
  font-weight: 500;
`;

export const SettingsContent = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
  padding: 30px;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

export const SettingsSectionTitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 24px;
`;

export const SettingsGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const SettingItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SettingLabel = styled.label`
  font-weight: 500;
  color: #374151;
  font-size: 14px;
`;

export const SettingInput = styled.input`
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s ease;
  background: white;

  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }
`;

export const SettingTextarea = styled.textarea`
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s ease;
  background: white;
  resize: vertical;
  min-height: 80px;

  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }
`;

export const SettingSelect = styled.select`
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s ease;
  background: white;

  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }
`;

export const ToggleSwitch = styled.label`
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
  cursor: pointer;
`;

export const ToggleInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
`;

export const ToggleSlider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 24px;

  &:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
  }

  ${ToggleInput}:checked + & {
    background-color: #3b82f6;
  }

  ${ToggleInput}:checked + &:before {
    transform: translateX(26px);
  }
`;

export const ChangePasswordButton = styled.button`
  background: #3b82f6;
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
  width: fit-content;

  &:hover {
    background: #2563eb;
  }
`;

export const ThemeOptions = styled.div`
  display: flex;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const ThemeOption = styled.label`
  cursor: pointer;
`;

export const ThemeInput = styled.input`
  display: none;
`;

export const ThemePreview = styled.div`
  width: 80px;
  height: 60px;
  border-radius: 8px;
  border: 2px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &.light {
    background: #ffffff;
    color: #1e293b;
  }

  &.dark {
    background: #1e293b;
    color: #ffffff;
  }

  ${ThemeInput}:checked + & {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }
`;

export const ThemeName = styled.div`
  font-size: 12px;
  font-weight: 500;
`;
